<template>
  <div>
    <div class="card-body print-form" id="receiptData">
      <b-row class="">
        <b-col cols="12">
          <table style="width: 400px; font-weight: bold; color: grey">
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span>
                  <h6
                    class="mb-0 tx-rubik text-center company_name text-uppercase shop-header"
                  >
                    {{ new Date() | formatDateTime }}
                  </h6>
                </span>
              </td>
            </tr>
          </table>
          <table style="width: 400px; margin: 0px 5px">
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span>
                  <h1
                    class="mb-0 tx-rubik text-center company_name text-uppercase shop-header"
                  >
                    KOT BILL
                  </h1>
                </span>
              </td>
            </tr>
          </table>

          <hr class="hor_line" />
        </b-col>
      </b-row>

      <b-row>
        <!-- {{OrderDetailsData}} -->
        <b-col class="font-weight-bold">
          <table>
            <div class="row">
              <tr>
                <td>
                  <div class="col-lg-4">
                    <div
                      class="col-lg-4 textAllignments"
                      v-if="OrderDetails && OrderDetails.guest"
                    >
                      <span
                        class="tx-rubik"
                        style="color: black; text-align: left"
                      >
                        Customer
                      </span>
                    </div>

                    <div
                      class="col-lg-4 textAllignments"
                      v-if="OrderDetails.table"
                    >
                      <span
                        class="tx-rubik"
                        style="color: black; text-align: left"
                      >
                        OrderPlace
                      </span>
                    </div>
                    <div
                      class="col-lg-4 textAllignments"
                      v-if="OrderDetails && OrderDetails.waiter"
                    >
                      <span
                        class="tx-rubik"
                        style="color: black; text-align: left"
                      >
                        Waiter
                      </span>
                    </div>

                    <div class="col-lg-4 textAllignments">
                      <span
                        class="tx-rubik"
                        style="color: black; text-align: left"
                      >
                        Order type
                      </span>
                    </div>
                  </div>
                </td>
                <td class="numformat1">
                  <div class="col-lg-4">
                    <div class="col-lg-12">
                      <span class="numformat" style="font-size: 45px">
                        <b>{{ TicketNumber }}</b></span
                      >
                    </div>
                  </div>
                </td>
                <td>
                  <div class="col-lg-4">
                    <div
                      class="col-lg-4 textAllignments"
                      v-if="OrderDetails && OrderDetails.guest"
                    >
                      <span
                        class="tx-rubik"
                        style="color: black; text-align: left"
                      >
                        {{ OrderDetails.guest.name }}
                      </span>
                    </div>
                    <div
                      class="col-lg-4 textAllignments"
                      v-if="OrderDetails.table"
                    >
                      <span
                        class="tx-rubik"
                        style="color: black; text-align: left"
                      >
                        {{
                          OrderDetails.table.name
                            ? OrderDetails.table.name
                            : null
                        }}
                      </span>
                    </div>
                    <div
                      class="col-lg-4 textAllignments"
                      v-if="OrderDetails && OrderDetails.waiter"
                    >
                      <span
                        class="tx-rubik"
                        style="color: black; text-align: left"
                      >
                        {{ OrderDetails.waiter.name }}
                      </span>
                    </div>
                    <div
                      class="col-lg-4 textAllignments"
                      v-if="OrderDetails && OrderDetails.order_type"
                    >
                      <span
                        class="tx-rubik"
                        style="color: black; text-align: left"
                      >
                        {{ OrderDetails.order_type }}
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            </div>
          </table>
        </b-col>
      </b-row>
      <hr style="b margin-bottom: 10px" />

      <b-row>
        <b-col>
          <table style="width: 400px; margin: 0px 5px">
            <thead>
              <tr style="border-bottom: solid 2px">
                <th class="description" style="color: black; text-align: left">
                  Item
                </th>
                <th
                  class="description"
                  style="color: black; text-align: center"
                >
                  Unit
                </th>

                <th
                  class="quantity"
                  style="color: black; text-align: right; padding: 0px 0px"
                >
                  Qty
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(product, index) in Order"
                :key="index"
                style="border-top: dashed 1px"
              >
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 110px;
                  "
                >
                  <h6
                    class="text-left padding-top-0px"
                    v-if="product && product.dish"
                  >
                    {{ product.dish.name }}
                  </h6>
                  <h6
                    class="text-left padding-top-0px"
                    v-if="product && product.product"
                  >
                    {{ product.product.name }}
                  </h6>
                  <table class="width-100perc">
                    <tbody>
                      <tr
                        v-for="(item, index) in product.ingredients"
                        :key="index"
                        class="secondry-color text-left"
                      >
                        <td width="20px" class="text-right">+</td>
                        <td v-if="item">Add {{ item.name }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  class="text-center padding-top-0px"
                  v-if="product && product.unit"
                >
                  {{ product.unit.name }}
                </td>

                <td
                  class="quantity"
                  style="color: black; text-align: right; width: 30px"
                >
                  <span
                    style="color: black; text-align: right"
                    class="tx-rubik"
                    v-if="product.adjust_quantity > 0"
                  >
                    {{ product.adjust_quantity }}g
                  </span>

                  <span
                    style="color: black; text-align: right"
                    class="tx-rubik"
                    v-else
                  >
                    {{ product.quantity }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

          <table style="width: 400px; margin: 0px 5px">
            <tr>
              <td
                colspan="2"
                class="description"
                style="color: black; text-align: left"
              >
                <hr style="border-top: solid 1px; margin: 1px" />

                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  <!-- No of items - {{ Order.length }} -->
                </span>
              </td>
            </tr>

            <tr style="margin-top: 30px">
              <td
                colspan="2"
                style="
                  font-size: 12px;
                  padding-top: 20px;
                  color: black;
                  text-align: center;
                "
              >
                Powered by SpeedCodeLabs (Pvt) Ltd | 0212 211 599
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrintBill',
  props: {
    TicketNumber: {
      type: String,
      default: '',
    },
    Order: {
      type: Array,
      default: [],
    },
    OrderDetails: {
      type: Array,
      default: [],
    },
  },
  components: {},
  computed: {},
  methods: {
    print() {
      this.$htmlToPaper('receiptData');
    },
  },
};
</script>
<style>
.description,
.description {
  width: 80px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.unit-price,
.unit-price {
  width: 90px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.unit-price-text {
  text-align: right;
}

.quantity,
.quantity {
  width: 40px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.discount,
.discount {
  width: 90px;
  word-break: break-all;
  padding: 0px 10px;
}

.amount,
.amount {
  width: 100px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.centered {
  text-align: center;
  align-content: center;
}

.ticket {
  width: 155px;
  max-width: 155px;
}

img {
  max-width: inherit;
  width: inherit;
}
#receiptData {
  width: 100%;
  background: white;
}
</style>
